import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';
import { BlockNames } from '../block.types';

export function addBlocks(piral: PiletApi) {
	const LazySendOnboardingAgreementButton = React.lazy(
		() => import('./SendOnboardingAgreementButton')
	);
	piral.registerExtension(BlockNames.SendAgreementButton, props => (
		<React.Suspense fallback={<Spin />}>
			<LazySendOnboardingAgreementButton {...props} />
		</React.Suspense>
	));
}
